import INFTCollections from '../../models/INFTCollections'
import GeneralCard from '../../nftFormats/Generals/Card/GeneralCard'
import GeneralDetail from '../../nftFormats/Generals/Detail/GeneralDetail'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'

export const BraiNFTData: INFTCollections[] = [
  {
    id: 'BraiNFT',
    tokenAddress: '0x18a884faea157c378b1508514e5d11e82b27f15a',
    name: 'BraiNFT',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x584b18F864F2571aaB57BbAAb72790D03958c8aF',
    logo: 'https://ipfs.io/ipfs/QmNzFak9umVELSW9FxaFAddaNtFG52KPVJXHdne869ifXU',
    twitter: 'brainftsio',
    discord: 'https://discord.com/invite/5phrecbdJy',
    website: 'https://brainfts.io',
    apiLink: 'https://brainfts.io/nft/'
  }
]

export const YetiSwapCategoryData = {
  [BraiNFTData[0].tokenAddress.toLowerCase()]: BraiNFTData[0].category
}
